import React from 'react';
export class CnListProItemDescription extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemDescription.displayName = 'CnListProItemDescription';
